import React, { useContext } from "react";
import Menu from "./Menu";
import { Link } from "react-router-dom";
import { AuthContext } from "../../store/AuthContext";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { UserContext } from "../../store/UserContext";

const Header = () => {
  const { user, loginUser, perfil, logout, newSession } =
    React.useContext(AuthContext);
  const idCorreios = user?.sub;
  const [menuAberto, setMenuAberto] = React.useState(false);
  const [menuLateralAberto, setMenuLateralAberto] = React.useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { usuario } = useContext(UserContext);
  function handleHamburgerClick({ target }) {
    setMenuAberto(!menuAberto);
  }

  function handleMenuLateralAberto({ target }) {
    setMenuLateralAberto(!menuLateralAberto);
  }
  function novaSessao() {
    navigate("/abrirNovaSessao");
  }
  React.useEffect(() => {
    const menuAbertoStorage = window.localStorage.getItem("menuAberto");
    if (!menuAbertoStorage) return;

    setMenuAberto(menuAbertoStorage === "true");
  }, []);

  React.useEffect(() => {
    if (menuLateralAberto) {
      document.body.addEventListener("click", fechaMenuLateral);
    } else {
      document.body.removeEventListener("click", fechaMenuLateral);
    }
  }, [menuLateralAberto]);

  const fechaMenuLateral = React.useCallback(() => {
    setMenuLateralAberto(false);
  }, []);

  React.useEffect(() => {
    if (menuAberto) {
      document.querySelector("body").classList.add("menu-aberto");
    } else {
      document.querySelector("body").classList.remove("menu-aberto");
    }
    window.localStorage.setItem("menuAberto", menuAberto);
  }, [menuAberto]);

  return (
    <section id="menu">
      {/* <a
        className={`hamburger ${menuAberto ? 'aberto' : ''}`}
        tabIndex="1"
        onClick={handleHamburgerClick}
      ></a>*/}
      <Link className="logo" to="/principal"></Link>
      <a className="pesquisar"></a>

      {user ? (
        <>
          <a
            onClick={handleMenuLateralAberto}
            className={`nome ${menuLateralAberto ? "aberto" : ""}`}
            tabIndex="1"
            title={usuario?.nome ? usuario.nome.toUpperCase() : ""}
          >
            {/*user.nome && <>{user.nome.toUpperCase()}</>*/}
            {usuario?.nome && <>{usuario?.nome.toUpperCase()}</>}
            {/*dadosUsuario?.nome && <>{dadosUsuario?.nome.toUpperCase()}</>*/}
          </a>
          <div className={`dd ${menuLateralAberto ? "aberto" : ""}`}>
            <a onClick={() => newSession()}> {t("login.exit")}</a>
          </div>
        </>
      ) : (
        <a className="entrar" onClick={() => loginUser()}></a>
      )}
      <Menu aberto={menuAberto} />
    </section>
  );
};

export default Header;
